import { Component, OnInit, ViewEncapsulation, SimpleChanges, ViewChild, ElementRef, Input } from '@angular/core';
import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { VraagboomNumberResultaat } from '@models/vragenboom';
import { Antwoord, Vraag } from '@models/claims';
import { RegexValidator } from '../../../utils/validation/regex.validator';
import { NumberValidator } from '../../../utils/validation/number.validator';
import { DataService } from '@components/public_api';

@Component({
  selector: 'app-bedrag',
  templateUrl: './bedrag.component.html',
  styleUrls: ['./bedrag.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BedragComponent extends BaseVraagControlDirective<VraagboomNumberResultaat> implements OnInit {
  @ViewChild('BedragField', { static: true }) BedragElement: ElementRef;
  @Input() isCurrentVraag: boolean;

  resultaat: VraagboomNumberResultaat = new VraagboomNumberResultaat();

  errormessageBedrag: string;
  placeholder = '';
  bedragFocus = false;
  bedragHadFocus = false;
  bedragHasFocus = false;
  bedragRequired = false;

  get bedrag(): string {
    return this.resultaat.value;
  }
  set bedrag(val: string) {
    this.resultaat.value = val ? val.toString() : val;
    if (!this.isCurrentVraag) {
      return;
    }
    this.notifyAntwoord();
  }

  constructor(_dataService: DataService) {
    super(_dataService);
  }

  ngOnInit() {
    if (this.vraag?.antwoorden?.length > 0) {
      this.errormessageBedrag = this.vraag.antwoorden[0].foutmelding;
      this.bedragRequired = this.vraag.antwoorden[0].verplicht;
    }
  }

  initialize(changes: SimpleChanges): void {
    if (this.antwoordResultaat != null && this.antwoordResultaat.vraag.id === this.vraag.id && this.antwoordResultaat.resultaat != null) {
      this.bedrag = this.antwoordResultaat.resultaat.value;
    } else {
      this.bedrag = null;
    }
    this.placeholder = this.vraag.antwoorden[0].standaard_waarde_tekst;
    this.BedragElement.nativeElement.focus();
  }

  geefEuro(): string {
    return "\u20AC";
  }

  hasError(): boolean {
    if (this.bedragHadFocus) {
      if (this.isBedragLeeg()) {
        return (this.bedragRequired || this.submitClicked);
      } else {
        return !this.validBedrag()
      }
    }
    return false;
  }

  notifyAntwoord() {
    let antwoorden: Antwoord[] = [];
    if (this.vraag?.antwoorden?.length > 0) {
      antwoorden = this.vraag.antwoorden;
    }

    this.setAntwoord(antwoorden, this.resultaat);
  }

  setBedragFocus(value: boolean) {
    this.bedragHasFocus = value;
    if (!value) {
      this.BedragElement.nativeElement.blur();
      this.bedragHadFocus = true;

      if (this.antwoordResultaat.resultaat.value && this.validBedrag()) {
        var test = Number(this.antwoordResultaat.resultaat.value.replace(',', '.')).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\./g, '');
        if (test !== "NaN") {
          this.bedrag = test;
        }
      }
    }
  }

  isBedragLeeg(): boolean {
    return (this.bedrag == null) || (this.bedrag.length === 0);
  }

  validBedrag(): boolean {
    return RegexValidator.isValidRegexAnswer(this.vraag.antwoorden[0], this.resultaat.value);
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomNumberResultaat): boolean {
    return antwoorden?.length >= 1 &&
      NumberValidator.isValidBedrag(vraag, resultaat) &&
      RegexValidator.isValidRegexAnswer(antwoorden[0], resultaat.value);
  }
}
